(function ($, Drupal, drupalSettings, once) {
  Drupal.behaviors.bg = {
    attach: function (context, settings) {
      once("bg", "*[data-bg]", context).forEach(function (element) {
        var bg = $(element).data("bg");
        if (bg.substr(0, 1) === "#") {
          $(element).css({
            "background-color": bg,
          });
        } else {
          $(element).css({
            "background-image": "url(" + bg + ")",
          });
        }
      });
    },
  };
})(jQuery, Drupal, drupalSettings, once);
